<div class="orch-identity">
  @if (nameUrl(); as url) {
    <a class="orch-identity__name" [routerLink]="url">{{ name() | translate }}</a>
  } @else {
    <strong class="orch-identity__name">{{ name() | translate }}</strong>
  }
  @for (line of lines(); track line.kind + line.title) {
    <div class="orch-identity__line">
      <i [class]="line.icon" [attr.aria-hidden]="true"></i>
      <span class="orch-identity__kind">{{ line.kindLabelKey | translate }}</span>
      <app-copyable-identifier
        [value]="line.title"
        [display]="line.label"
        [link]="line.url"
      ></app-copyable-identifier>
    </div>
  }
</div>
